<h2 mat-dialog-title *ngIf="editPool.id === undefined"><i class="fas fa-plus me-2"></i>Create Pool</h2>
<h2 mat-dialog-title *ngIf="editPool.id !== undefined"><i class="fas fa-plus me-2"></i>Edit Pool for {{editPool.name}}</h2>
<mat-dialog-content class="mat-typography">
  <form #PoolForm="ngForm" id="PoolForm" name="PoolForm">
    <div class="row">
      <div class="form-group col-sm-6 mb-0">
        <mat-form-field class="d-block">
          <input matInput type="text" id="poolName" name="poolName" required [(ngModel)]="editPool.name"
            #poolName="ngModel" placeholder="Pool Name">
        </mat-form-field>
      </div>
      <div class="form-group col-sm-6 mb-0">
        <mat-form-field class="d-block">
          <input matInput type="text" id="poolDescription" name="poolDescription" required
            [(ngModel)]="editPool.description" #poolDescription="ngModel" placeholder="Pool Description">
        </mat-form-field>
      </div>

      <div class="form-group col-sm-6 mb-0">
        <mat-form-field class="d-block">
          <input matInput type="text" id="integrationId" name="integrationId" [(ngModel)]="editPool.integrationId"
            #integrationId="ngModel" placeholder="Integration Id">
        </mat-form-field>
      </div>
      <div class="form-group col-sm-6 mb-0" *ngIf="editPool.id === undefined">
        <div class="mt-3">
          <mat-checkbox class="isActiveCheck" name="isActive" [checked]="true"  type="checkbox"
            [(ngModel)]="editPool.isActive" #isActive="ngModel" color="primary"> Active
          </mat-checkbox>
        </div>
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
   <div class="custom-dialog-actions">
    <div class="btn-group">
      <button *ngIf="!submitting" type="submit" form="PoolForm" class="custom-button save-button"
        [disabled]="PoolForm.invalid" (click)="savePoolClicked()">
        <span class="fa-icon-wrapper"><i class="fas fa-save"></i></span>Save
      </button>
      <mat-spinner *ngIf="submitting" [diameter]="20"></mat-spinner>
      <button class="custom-button cancel-button" (click)="cancelClicked(false)">
        <span class="fa-icon-wrapper"><i class="fas fa-times"></i></span>Cancel
      </button>
    </div>
   
  </div>

</mat-dialog-actions>